import * as React from "react";
import { forwardRef } from "react";
const SvgLocation = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 11 12", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M4.693 11.892C4.5 11.816 0 9.961 0 5.25a5.25 5.25 0 1 1 10.5 0c0 4.71-4.5 6.566-4.694 6.642a1.5 1.5 0 0 1-1.113 0M1.5 5.25C1.5 9 5.25 10.5 5.25 10.5S9 9 9 5.25a3.75 3.75 0 0 0-7.5 0m2.25 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" }));
const ForwardRef = forwardRef(SvgLocation);
export { ForwardRef as ReactComponent };
